// extracted by mini-css-extract-plugin
export default {"firstColButton":"UserInfo_firstColButton__f1Nqj","button":"UserInfo_button__E+zYg","removeButtons":"UserInfo_removeButtons__RY3ot"};